const SERVICES = [
  {
    id: "field_os",
    name: "Field OS",
    icon: "workspaces",
    path: "/field-os",
    description: "Manage your field teams, activities and operations.",
  },
  // {
  //   id: "voice",
  //   name: "Voice",
  //   icon: "dialer_sip",
  //   path: "/voice-os",
  //   description: "Manage business calls, call centers and call analytics.",
  // },
  // {
  //   id: "wacc",
  //   name: "Whatsapp",
  //   icon: "forum",
  //   path: "/wacc",
  //   description: "Manage whatsapp conversations with your customers.",
  // },
  {
    id: "comms",
    name: "Communication Center",
    icon: "perm_phone_msg",
    path: "/comms",
    description: "Manage your business communications over voice and whatsapp.",
  },
];

export default SERVICES;
